/* Scroll-reveal: añade .in-view a cada .shopify-section al entrar en viewport */
(function () {
  if (!('IntersectionObserver' in window)) {
    /* Fallback: mostrar todo si el navegador no soporta IntersectionObserver */
    document.querySelectorAll('.shopify-section').forEach(function (el) {
      el.classList.add('in-view');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target); /* Una sola vez por sección */
        }
      });
    },
    { threshold: 0.08 }
  );

  document.querySelectorAll('.shopify-section').forEach(function (el) {
    observer.observe(el);
  });
})();
